import RestaurantsData from "../../components/hotel/datamanagement/RestaurantsData";

export default function RestaurantsPage() {
  return <RestaurantsData />;
}

